module.exports = __webpack_public_path__ + "img/dropdownicon.08bab006.svg";